import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../../../service/seo.service';
import { NavigationEnd, Router } from '@angular/router';
import { UrlcanonicaService } from '../../../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { LicitacionService } from '../../../../service/licitacion.service';


@Component({
  selector: 'app-ofertas-de-licitacion',
  templateUrl: './ofertas-de-licitacion.component.html',
  styleUrls: ['./ofertas-de-licitacion.component.css']
})
export class OfertasDeLicitacionComponent implements OnInit {
	private subscription: Subscription = new Subscription();
	RouteText : any;
	tituloseo: any;
	urlcanonicaseo: any;
	imagenseo: any;
	keywordsseo: any;
	descripcionseo: any;
	toggle:boolean = true;
	estatusUpdate: any;
	CaliidUpda: any;
	calificacionUpdate: any;
	formupdate: any;
	editar = false;
	success= false;
	fail = false;
	isReadonly=false;
	addd = false;
	ofertas!: any[];
	familias!: any[];
	parfiltros:any;
	codigoProductoUpdate:any;
	productoUpdate:any;
	familiaUpdate:any;
	mensajeTextAreaUpdate:any;
	p: number = 1;
	urlPdf: any;
  ///////

	constructor( 
		private meta: Meta,
		private title: Title,
		private _seoService: SeoService,
		private router: Router,
		private _licitacionservice: LicitacionService,
		private _urlcanonicaservice: UrlcanonicaService
		) { 
			if((sessionStorage.getItem('token') == null || sessionStorage.getItem('token') == 'null')||(sessionStorage.getItem('user') == null || sessionStorage.getItem('user') == 'null')){
				this.router.navigate(['/licitaciones/administrador/login']);
			}
			this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
				this.RouteText = event;
				this.getSEO(event.url)
			});
		}

	getSEO(page: string) {
		this._seoService.getSEO(page).subscribe((resp: any) => {
			this.tituloseo = resp.titulo;
			this.descripcionseo = resp.descripcion;
			this.urlcanonicaseo = resp.urlcanonica;
			this.imagenseo = resp.image;
		
			this._urlcanonicaservice.createCanonicalLink();
			this.title.setTitle(this.tituloseo)
			this.meta.updateTag({name: 'description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:card',content: 'summary'})
			this.meta.updateTag({property: 'twitter:site',content: '@fundacionbest'})
			this.meta.updateTag({property: 'twitter:title',content: 'Fundación BEST'})
			this.meta.updateTag({property: 'twitter:description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:url',content: 'https://fundacionbest.org.mx/licitaciones/login'})
			this.meta.updateTag({property: 'og:title',content: this.tituloseo})
			this.meta.updateTag({property: 'og:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:description',content: this.descripcionseo})
		});
	}

	ngOnInit(): void {
		this.getFamilias();
		this.getOfertas();
	}

	addOferta(){this.addd = true;}
	
	getOfertas() {
        this.subscription.add(
            this._licitacionservice.getproductosAdmin(sessionStorage.getItem('token')).subscribe((resp: any) => {
				console.log(resp)
				this.ofertas = resp;
            })
        );
    }

	getFamilias() {
        this.subscription.add(
            this._licitacionservice.getFamiliaIntere().subscribe((resp: any) => {
				this.familias = resp;
            })
        );
    }

	pdfInput(event: any) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.size < 5000000) {
                if (!/(pdf)$/ig.test(file.type)) {
                    alert("Invalid file type: "+file.type+".  Please use DOC, PDF or Zip.");
                }else{
                    this._licitacionservice.UploadImage(file).subscribe((resp: any) => {
                        this.urlPdf = resp.substr(2);
                    });
                }
            } else {
                alert("Invalid file size: "+file.size+".  Please use file to size 5MB");
            }
        }
    }


	confirmacionAgregar(form: NgForm) {
		var insert = {
			Codigo : form.value.CodigoProducto,
			Producto : form.value.Producto,                              
			UrlFichaTecnica : this.urlPdf,
			DetalleOferta : form.value.DetalleOferta,
			Idfamilia : form.value.FamiliaId,
		
		}
		this.subscription.add(
            this._licitacionservice.postInsertProducto(insert, sessionStorage.getItem('token') ).subscribe((resp: any) => {
				form.reset();
				this.addd = false;
				this.getOfertas();
            })
        );
		
	}

	change(calificacion: any){
		this.estatusUpdate = calificacion.activo;
		this.codigoProductoUpdate = calificacion.codigo;
		this.familiaUpdate = calificacion.idfamilia;
		this.mensajeTextAreaUpdate = calificacion.detalleOferta;
		this.productoUpdate = calificacion.producto;
		this.editar = true;
	}


	cancel() {
		this.editar = false;
		this.addd = false;
	}
	UpdateCalifo(form: NgForm) {
		this.formupdate = form.value;
		this.success= true;
		this.editar = false;
	}
	closeok() {
		if(this.formupdate.estatusUpdate == null || this.formupdate.estatusUpdate == 'null'){this.formupdate.estatusUpdate = false}
		var post = {
			Id: this.CaliidUpda,
			Codigo : this.formupdate.codigoProductoUpdate,
			Producto : this.formupdate.productoUpdate,                              
			UrlFichaTecnica : this.urlPdf,
			DetalleOferta : this.formupdate.mensajeTextAreaUpdate,
			Idfamilia : this.formupdate.familiaUpdate,
			Activo : this.formupdate.estatusUpdate
		}
		this.subscription.add(
            this._licitacionservice.postUpdateProducto(post, sessionStorage.getItem('token') ).subscribe((resp: any) => {
				this.getOfertas();
				this.success= false;
				this.editar = false;
            })
        );
	}

	closefail() {
		this.success= false;
		this.editar = true;
	}
}